import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  GET_ORG_USER,
  ADD_ORG_USER
} from "@routes";

const apiConfig = [
  {
    name: "getOrganizationUser",
    method: "get",
    url: GET_ORG_USER,
    stateKey: "organizationUsersData",
  },
  {
    name: "addOrganizationUser",
    method: "post",
    url: ADD_ORG_USER,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    organizationUsersData: [],
    selectedData: {},
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "organizationUsers",
  apiConfig,
  customReducers,
);

const organizationUsersSlice = slice;

export default organizationUsersSlice.reducer;

export const actionsExports = actions;

export const {
  getOrganizationUser,
  addOrganizationUser
} = thunks;

export const { rowSelect } =
  actionsExports;
